import React from "react";
import { CFormInput } from "@coreui/react";

const Input = (props) => {
  return <CFormInput {...props} {...props.input} />;
};

export default Input;
